import styled from "styled-components"
import { Container } from "client/components"

export const ContainerStyled = styled(Container)`
    padding-bottom: 60px;
`
export const Title = styled.label`
    padding: 10px 15px 3px;
    margin: 0;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.defaultTextColor};
`
